const API_URL = import.meta.env.VITE_ADMIN_API_URL;

export async function adminFetch<T = any>(
  path: string,
  token: string,
  options?: { method?: string; body?: any }
): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    method: options?.method || 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options?.body ? { 'Content-Type': 'application/json' } : {}),
    },
    body: options?.body ? JSON.stringify(options.body) : undefined,
  });

  if (!response.ok) {
    const text = await response.text();
    let message: string;
    try {
      message = JSON.parse(text).message;
    } catch {
      message = text;
    }
    throw new Error(message || `Request failed: ${response.status}`);
  }

  return response.json();
}
